import React, {useState} from 'react';
import {navigate} from '@reach/router';
import classNames from 'classnames';
import {Form, Formik, Field} from 'formik';
import InputMask from 'react-input-mask';
import * as Yup from 'yup';

import {Alert, Button, FormFeedback, FormGroup, Input, Label, CustomInput, ModalBody} from 'reactstrap';
import {useUserDispatch} from 'contexts/user';
import {submitForm} from 'utils/forms';
import './QuizForm.scss';
import QuizContactForm from 'components/Forms/QuizForm/components/ContactInfo';
import Modal from 'components/Modal';
import QuizQuestionsForm from 'components/Forms/QuizForm/components/QuizQuestionsForm';

export default function QuizForm({disableNavigate = false, fromInfographic = false, ...props}) {
  const [step, setStep] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const [navigateOnClose, setNavigateOnClose] = React.useState(false);

  const modalToggle = () => setIsOpen((v) => !v);

  const onComplete = React.useCallback(() => {
    modalToggle();
    !disableNavigate && navigate('/masterclass/?o=quiz');
  }, []);

  const onStepComplete = React.useCallback((step) => step === 1 && setNavigateOnClose(true), []);

  const toggle = React.useCallback(() => {
    if (navigateOnClose && !disableNavigate) navigate('/masterclass/?o=quiz');
    modalToggle();
  }, [navigateOnClose]);

  const userDispatch = useUserDispatch();

  return (
    <>
      {(() => {
        switch (step) {
          default:
          case 0:
            return (
              <QuizContactForm
                onSubmit={(values, actions) => {
                  userDispatch({type: 'SET_USER', payload: {firstname: values.firstname, email: values.email}});
                  setStep(1);
                  modalToggle();
                  onStepComplete(1);
                }}
              />
            );
          case 1:
            return (
              <Modal className="modal-dialog-centered" {...props} isOpen={isOpen} toggle={toggle} size="lg">
                <ModalBody className="px-4 pt-0 pb-4">
                  <QuizQuestionsForm
                    onComplete={() => {
                      onComplete();
                      onStepComplete(2);
                    }}
                  />
                </ModalBody>
              </Modal>
            );
        }
      })()}
    </>
  );
}
